import React from 'react';
import '../style.css'

const Story = () => {
  return (
      <div className="wrapper_story">
        <h3 className="heading_medium">Nope. Not just another COVID APP!
        </h3>
        <p className='heading_medium'>Time for <span className='novid'>Novid</span></p>
        <h4 className="heading_small">Who said that controlling new COVID cases in your work environment should be difficult? </h4>
        <p className="paragraph">Controlling a risk of spreading of new cases in your workplace can drastically increase security of your company ......</p>
        <p className="paragraph">But there is even more...</p>
      </div>
  );
};

export default Story;
